import { render } from "./DashboardContentSwitcher.vue?vue&type=template&id=3f8ac860&scoped=true"
import script from "./DashboardContentSwitcher.vue?vue&type=script&lang=ts"
export * from "./DashboardContentSwitcher.vue?vue&type=script&lang=ts"

import "./DashboardContentSwitcher.vue?vue&type=style&index=0&id=3f8ac860&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3f8ac860"

export default script